module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('normalBar', {
    attrs: {
      "title": "确认订单",
      "path": _vm.gobackPath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "default-panel firm-panel"
  }, [_c('div', {
    staticClass: "grey-bg-sec"
  }, [(!_vm.isWxLogin && !_vm.isSignSuccess) ? _c('div', {
    staticClass: "address-sec",
    on: {
      "click": function($event) {
        _vm.goAddressList(0)
      }
    }
  }, [_c('span', {
    staticClass: "big-size"
  }, [_vm._v("请新建收货地址")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e(), _vm._v(" "), (!_vm.isSignSuccess && _vm.isWxLogin) ? _c('div', {
    staticClass: "address-sec",
    on: {
      "click": function($event) {
        _vm.goAddressList(2)
      }
    }
  }, [_c('span', {
    staticClass: "big-size"
  }, [_vm._v("请新建收货地址")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.isSignSuccess && _vm.addressCode == '03206') ? _c('div', {
    staticClass: "address-sec",
    on: {
      "click": function($event) {
        _vm.goAddressList(3)
      }
    }
  }, [_c('span', {
    staticClass: "big-size"
  }, [_vm._v("请新建收货地址")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.isSignSuccess && _vm.addressCode == '03209') ? _c('div', {
    staticClass: "address-sec",
    on: {
      "click": function($event) {
        _vm.goAddressList(1)
      }
    }
  }, [_c('span', {
    staticClass: "big-size"
  }, [_vm._v("无符合条件的配送地址，点击修改")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.isSignSuccess && _vm.orderAddress.id) ? _c('div', {
    staticClass: "address-sec",
    on: {
      "click": function($event) {
        _vm.goAddressList(1)
      }
    }
  }, [_c('div', {
    staticClass: "address-content"
  }, [_c('p', {
    staticClass: "big-size"
  }, [_vm._v(_vm._s(_vm.orderAddress.recipientName)), _c('span', {
    staticClass: "last"
  }, [_vm._v("收")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orderAddress.address))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("filterPhone")(_vm.orderAddress.recipientMobile)))])]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "grey-bg-sec"
  }, [_c('div', {
    staticClass: "extra-sec"
  }, [_c('div', {
    staticClass: "text-list"
  }, [(_vm.hasOwnDelivery) ? _c('mt-cell', {
    attrs: {
      "title": "配送日期",
      "label": "(限自营配送)"
    }
  }, [_c('span', {
    staticClass: "text",
    on: {
      "click": _vm.openPicker
    }
  }, [_vm._v(_vm._s(_vm.deliveryDate ? _vm.deliveryDate : '未选择'))]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.hasOwnDelivery) ? _c('mt-cell', {
    attrs: {
      "title": "配送时间",
      "label": "(限自营配送)"
    }
  }, [_c('span', {
    staticClass: "text",
    on: {
      "click": _vm.openTimer
    }
  }, [_vm._v(_vm._s(_vm.deliveryTime ? _vm.deliveryTime : '未选择'))]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-right"
  })]) : _vm._e(), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "订单备注"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderMarks),
      expression: "orderMarks"
    }],
    staticClass: "input-marks orderMarks",
    attrs: {
      "maxlength": "60",
      "placeholder": "限定60字（请将购买需求在备注中详细说明）"
    },
    domProps: {
      "value": (_vm.orderMarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderMarks = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _vm._l((_vm.preOrder), function(itemList, index) {
    return _c('div', {
      key: index,
      staticClass: "grey-bg-sec"
    }, [_c('div', {
      staticClass: "gift-sec"
    }, [_c('div', {
      staticClass: "gift-header"
    }, [_vm._v("·"), _c('span', {
      staticClass: "title-tips"
    }, [_vm._v(_vm._s(itemList.preOrderName))]), _vm._v("· (" + _vm._s(itemList.deliveryTypeDesc) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "gift-body"
    }, _vm._l((itemList.goodsList), function(item) {
      return _c('router-link', {
        key: index,
        attrs: {
          "to": {
            path: '/productdetail/' + item.goodsChannelId,
            query: {
              url: _vm.router + '?url=' + _vm.gobackPath
            }
          }
        }
      }, [_c('div', {
        staticClass: "media"
      }, [_c('div', {
        staticClass: "media-left"
      }, [(!!item.thumb) ? _c('img', {
        attrs: {
          "src": item.thumb,
          "alt": ""
        }
      }) : _c('img', {
        attrs: {
          "src": require("../../assets/images/default-pro-small.png"),
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "media-content"
      }, [_c('p', {
        staticClass: "m-title"
      }, [_c('span', [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('span', {
        staticClass: "m-small"
      }, [_vm._v("X" + _vm._s(item.goodsNum))])]), _vm._v(" "), _c('span', {
        staticClass: "m-subTitle"
      }, [_vm._v(_vm._s(item.skuPropertyValue))]), _vm._v(" "), _c('div', {
        staticClass: "m-operate"
      }, [_c('div', {
        staticClass: "m-operate-cont"
      }, [_c('span', {
        staticClass: "price text-red"
      }, [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(item.salePrice)))]), _vm._v(" "), (item.birthdayCardContent) ? _c('span', {
        staticClass: "text-grey"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t生日牌：" + _vm._s(item.birthdayCardContent) + "\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()])])])]), _vm._v(" "), (item.greetingCardContent) ? _c('div', {
        staticClass: "greetContent"
      }, [_c('span', {
        staticClass: "title"
      }, [_vm._v("祝福卡：")]), _c('span', {
        staticClass: "content"
      }, [_vm._v(_vm._s(item.greetingCardContent))])]) : _vm._e()])
    }))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "firm-bottom-sec"
  }, [_c('div', {
    staticClass: "firm-bottom-content"
  }, [_c('div', {
    staticClass: "firm-bottom-left"
  }, [_c('span', [_vm._v("\n\t\t\t\t\t合计："), _c('span', {
    staticClass: "text-red"
  }, [_vm._v("¥" + _vm._s(_vm._f("filterPrice")(_vm.firmAmount)))])]), _vm._v(" "), _c('span', {
    staticClass: "text-grey"
  }, [_vm._v("含运费")])]), _vm._v(" "), _c('span', {
    staticClass: "checkout-btn",
    class: {
      disabled: _vm.orderAddress.id ? '' : true
    },
    on: {
      "click": _vm.confirmOrder
    }
  }, [_vm._v("\n\t\t\t\t提交订单\n\t\t\t")])])]), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker",
    attrs: {
      "type": "date",
      "visibleItemCount": 5,
      "startDate": _vm.stDate,
      "year-format": "{value} 年",
      "month-format": "{value} 月",
      "date-format": "{value} 日"
    },
    on: {
      "confirm": _vm.confirmDate
    },
    model: {
      value: (_vm.pickerValue),
      callback: function($$v) {
        _vm.pickerValue = $$v
      },
      expression: "pickerValue"
    }
  }), _vm._v(" "), _c('mt-popup', {
    staticClass: "deliverPick",
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.timerShow),
      callback: function($$v) {
        _vm.timerShow = $$v
      },
      expression: "timerShow"
    }
  }, [_c('mt-picker', {
    attrs: {
      "slots": _vm.slots,
      "showToolbar": true,
      "visibleItemCount": 3
    },
    on: {
      "change": _vm.onValuesChange
    }
  }, [_c('span', {
    staticClass: "mint-datetime-cancel",
    on: {
      "click": function($event) {
        _vm.timerShow = false
      }
    }
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "mint-datetime-confirm",
    on: {
      "click": _vm.setDeliveryTime
    }
  }, [_vm._v("确定")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a68c86","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shoppingCart/firmOrder.vue
// module id = 567
// module chunks = 1